import React from "react";
import { useLocation } from "react-router-dom";
import "../styles/whatsapp.css";
import { WHATSAPP_NUMBER, API_BASE } from "../config";

function WhatsappButton({ productName }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) return null;

  const message = productName
    ? `Hi, I'm interested in ${productName}. Can you share more details?`
    : "Hi, I'm interested in your products. Can you share more details?";

  const handleClick = async () => {
    try {
      await fetch(`${API_BASE}/analytics/inquiry`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ product: productName || "general" }),
      });
    } catch (err) {
      console.error("Inquiry log failed:", err);
    }
  };

  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      onClick={handleClick}
      aria-label="Enquire on WhatsApp"
    >
      WhatsApp Enquiry
    </a>
  );
}

export default WhatsappButton;
